import script from "./SelectView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectView.vue?vue&type=script&setup=true&lang=ts"

import "./SelectView.vue?vue&type=style&index=0&id=8cb4ee82&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cb4ee82"]])

export default __exports__